<!-- /. App Header -->
<app-header class="app-header"></app-header>

<!-- /. Body app -->
<div class="app-body">
    <div>
        <router-outlet></router-outlet>
    </div>
</div>
<!-- /. Footer component -->
<usb-footer></usb-footer>
